import {
  Montserrat_400Regular,
  Montserrat_600SemiBold,
  Montserrat_700Bold,
} from '@expo-google-fonts/montserrat';
import { useFonts } from 'expo-font';

import { MaterialIcons } from '@fhs/material-icons';

export function useUiResources() {
  return useFonts({
    Montserrat: Montserrat_400Regular,
    MontserratSemiBold: Montserrat_600SemiBold,
    MontserratBold: Montserrat_700Bold,
    MaterialIcons,
    HeroSerifBold: require('../assets/fonts/heroserifbold.otf'),
  });
}
